


import { useStateManager } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import { FormRowView } from 'components/shared';
import InfoAlertView from "components/shared/views/InfoAlertView";
import React from 'react';
import { SVGAsset } from "res";
import "./mobile.css";
import TASPositivePayExceptionChecksMobileContentView from "../TASPositivePayExceptionChecksMobileContentView";

/**
 * @function TASPositivePayExceptionChecksMobileView
 * @return {React.Component}
 * @exported true
 * @description The "TAS Positive Pay Exception Checks" mobile view.
 */
export default function TASPositivePayExceptionChecksMobileView() {
    const { data, ui, onChange, onClear, onSearch, onSearchMobileButtonClick } = useStateManager();
    const checkForms = data.exceptionCheckForms;
    const hasSearchResults = data.exceptionCheckForms.length > 0;
    const search = data.search;
    const accountItems = search.accounts.reduce((acc, item) => {
        acc.push(
            <CustomSelectItem key={ item.id } value={ item.id }>{ item.name }</CustomSelectItem>
        )
        return acc;
    }, []);
    const numberOfChangesSaved = ui.search.didSaveChanges.numberOfChangesSaved;
    const updatedMessage = numberOfChangesSaved > 1
    ? `You have successfully updated ${ numberOfChangesSaved } exceptions.`
    : `You have successfully updated ${ numberOfChangesSaved } exception.`;

    const editExceptionChecksHaveReturnReasonError = search.editExceptionChecksHaveReturnReasonError;

    return (
        <div className="show-on-mobile tas-positive-pay-exception-checks-mobile-view-container">
            <div className="flex-container flex-vertical">
                { ui.search.didSaveChanges.isActive && 
                <div className="flex-container flex-horizontal past-review-cutoff-time-container">
                    <div className="set-width success-alert">
                        <InfoAlertView text={ updatedMessage } className="align-center checkmark-style"
                        dataPoint="TAS_Positive_Pay_View_Checks_Desktop_Successfully_Saved_Alert_View"
                        icon={ <SVGAsset id="check_circle" className="checkmark-icon material-symbols-outlined" /> } />
                    </div>
                </div>
                }
                <div className="flex-container flex-vertical search-container">
                    <div className="set-width account-container">
                        <FormRowView text="Account">
                            <CustomSelect active={ ui.search.account.isActive } value={ search.account.id } dataPoint="TAS_Positive_Pay_View_Checks_Desktop_Account_Select"
                                onChange={ onSearch("account") }>
                                { accountItems }
                            </CustomSelect>
                        </FormRowView>
                    </div>
                    <div className="flex-width review-cutoff-time-container">
                        <InfoAlertView className="align-center" dataPoint="TAS_Positive_Pay_View_Checks_Desktop_Time_Info_Alert"
                        text="Review cutoff time: 09:30 AM"
                        icon={ <SVGAsset id="schedule" className="material-symbols-outlined" /> }/>
                    </div>
                    { editExceptionChecksHaveReturnReasonError &&
                    <div className="flex-width error-alert-container">
                        <InfoAlertView className="alert set-width" text="Please provide return reason(s)." icon={ <SVGAsset id="AlertTriangleIcon" className="" /> } />
                        <div className="flex-width"></div>
                    </div>
                    }
                </div>
            </div>
            { ui.search.didSearch.isActive && hasSearchResults && 
            <TASPositivePayExceptionChecksMobileContentView/>
            }
            { !hasSearchResults
            && <div className="flex-width text-center no-results-container">
                <span>No exception is available.</span>
               </div>
            }
        </div>
    )
}